import { reactLocalStorage } from 'reactjs-localstorage';
import ReactGA from 'react-ga';
import { http } from '../../services/http';

export const sendEmail = (formData, token) => {
  const data = {
    token: token ?? reactLocalStorage.get('token'),
    email: formData.email,
    prices: formData.prices,
    imageOpen: formData.imageOpen,
    imageClose: formData.imageClose,
  };

  return dispatch => {
    ReactGA.event(
      {
        category: 'Shares',
        action: 'Send email',
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );

    http
      .post('/basket/share/email', data)
      .then(response => {
        dispatch({ type: 'GET_SHARE_EMAIL_SUCCESS', data: response.data.result.message });
      })
      .catch(err => {
        dispatch({ type: 'GET_SHARE_EMAIL_ERROR', data: err });
      });
  };
};

export const makeShortLink = token => {
  return dispatch => {
    const myToken = token ?? reactLocalStorage.get('token');
    http
      .post('/basket/share/link', { token: myToken })
      .then(response => {
        dispatch({ type: 'GET_SHARE_LINK_SUCCESS', data: response.data.result.hash });
      })
      .catch(err => {
        dispatch({ type: 'GET_SHARE_LINK_ERROR', data: err });
      });
  };
};

export const getPdf = (token, imageOpen, imageClose, prices) => {
  const myToken = token ?? reactLocalStorage.get('token');

  ReactGA.event(
    {
      category: 'Shares',
      action: 'Get PDF',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );

  return http
    .pdf('/basket/share/pdf', { token: myToken, imageOpen, imageClose, prices })
    .then(response => Promise.resolve(response))
    .catch(err => Promise.reject(err));
};
